import React, { useState, useEffect } from 'react';
import { Typography, Button, CircularProgress } from '@mui/material';
import { useSchedulesSchedulesDestroyMutation } from '../../../../services/GLOWClient';
import MuiDialog from '../../../../SystemDesign/MuiDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import theme from '../../../../theme';

const DeleteSchedule = ({ open, onClose, onSuccess, schedule }) => {
    const [dialogClosed, setDialogClosed] = useState(false);
    const [deleteSchedule, { isLoading: isDeleting }] = useSchedulesSchedulesDestroyMutation();
    
    // Reset dialog state when open/close changes
    useEffect(() => {
        if (open === false) {
            setDialogClosed(true);
        } else {
            setDialogClosed(false);
        }
    }, [open]);
    
    const handleDelete = async () => {
        if (!schedule || !schedule.schedule_id) {
            console.error('No schedule selected for deletion');
            return;
        }
        
        try {
            
            // Pass the ID directly as required by the API
            await deleteSchedule({ scheduleId: schedule.schedule_id }).unwrap();
            
            // Call success callback and close dialog
            onSuccess && onSuccess();
            onClose();
        } catch (error) {
            console.error('Failed to delete schedule:', error);
        }
    };
    
    // Content to be displayed in the dialog
    const confirmationContent = (
        <div style={{ padding: '16px 0' }}>
            <Typography variant="body1" style={{ marginBottom: '16px' }}>
                Êtes-vous sûr de vouloir supprimer cet horaire ?
            </Typography>
            <Typography variant="body2" color="error" style={{ marginTop: '8px' }}>
                Cette action est irréversible et supprimera toutes les données associées à cet horaire.
            </Typography>
        </div>
    );

    // Trigger button for the dialog - this is hidden as we're controlling the dialog externally
    const triggerButton = <Button style={{ display: 'none' }}>Open</Button>;

    return (
        <MuiDialog
            open={open}
            icon={<DeleteIcon />}
            triggerButton={triggerButton}
            title="Supprimer l'horaire"
            subtitle={`Supprimer définitivement l'horaire`}
            content={confirmationContent}
            existAction={true}
            actionTitle="Supprimer"
            actionFunction={handleDelete}
            onClose={dialogClosed}
            onExternalClose={onClose}
            isLoading={isDeleting}
            actionType="button"
            maxWidth="sm"
            disableAction={isDeleting}
        />
    );
};

export default DeleteSchedule;